import React, { useState, useEffect } from 'react'
import { Card, Button } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import { useAuth } from '@auth/auth-context'
import './SignupSuccess.scss'

const SignupSuccess = () => {
  const [countdown, setCountdown] = useState(10)
  const { logout } = useAuth()

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          setTimeout(() => logout(), 0)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [logout])

  const handleLoginClick = () => {
    setTimeout(() => logout(), 0)
  }

  return (
    <div className="signup-success">
      <div className="success-container">
        <Card className="success-card">
          <div className="success-content">
            <CheckCircleOutlined className="success-icon" />
            <h1>Account Created Successfully!</h1>
            <p className="success-message">
              Your account has been created and is ready to use. You can now log in to access your dashboard.
            </p>
            <div className="success-actions">
              <Button type="primary" size="large" onClick={handleLoginClick}>
                Go to Login
              </Button>
              <p className="countdown-text">Redirecting automatically in {countdown} seconds...</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default SignupSuccess
